
import {
  ref,
  computed,
  reactive,
  defineComponent,
  toRefs,
  onMounted,
  toRef,
  nextTick,
  watch,
} from "vue";
import { HttpService } from "@/core/index";
import PrintItem from "./header.vue";
import { TabService } from "@/core";
import ApprovalFlowLogTable from "../form-detail/approval-flow-log/index.vue";
import Attachment from "./attachment-table/index.vue";
import moment from "moment";
import { useStore } from "@/store";
import { useRouter } from "vue-router";
import QrcodeImage from "../qrcode/index.vue";
import { setDesLabelWidth } from "@/utils/index";
export default defineComponent({
  isGlobal: true,
  name: "FlowPrint",
  components: { PrintItem, ApprovalFlowLogTable, Attachment, QrcodeImage },
  props: {
    sections: {
      type: Array,
      default: () => [],
    },
    attachBizType: {
      type: String,
      default: "",
    },
    flowBizType: {
      type: String,
      default: "",
    },
    url: {
      type: String,
      default: "",
    },
    qrcodeUrl: {
      type: String,
      default: "",
    },
    bizNoLabelName: {
      type: String,
      default: "",
    },
    validStatusLabelName: {
      type: String,
      default: "",
    },
    labelWidth: {
      type: Number,
      default: 100,
    },
    projectName: {
      type: String,
      default: "",
    },
    contractStatusLabelNameKey: {
      type: String,
      default: "",
    },
  },
  emits: ["update:basicInfo", "update:attachList"],
  setup(props, { emit, slots }) {
    const router = useRouter();
    const store = useStore();
    const state = reactive({
      companyName: computed(() => {
        return (store.state.user.userInfoAccessToken as any)?.userResp.company;
      }),
      moduleType: computed(() => {
        const type = (slots as any).nav()[0]?.children;
        const tmp = type.split(">");
        return tmp[tmp.length - 1];
      }),
      pName: computed(() => {
        if (!props.projectName) {
          return basicInfo.value?.projectName;
        }
        return props.projectName;
      }),
      printTitle: computed(() => {
        return `【${state.companyName}】${state.pName}${moment().format("YYYYMMDDHHmmss")}-${
          state.moduleType
        }`;
      }),
      id: computed(() => {
        const t = props.url.split("/");
        return t[t.length - 1];
      }),
      nowStr: moment().format("YYYY/MM/DD HH:mm"),
      selectedCheckbox: [],
      selectedSection: [
        { label: "标题", value: "header", sort: 1, show: true },
        { label: "基本信息", value: "basic", sort: 2, show: true },
        { label: "附件", value: "attach", sort: 10, show: true },
        { label: "协作日志", value: "flow", sort: 11, show: true },
        { label: "二维码", value: "qrcode", sort: 12, show: true },
      ],
      checkboxes: computed(() => {
        let tmp = [] as any;
        props.sections.forEach((o: any) => {
          let t = state.selectedSection.findIndex((i: any) => i.value === o.value);
          if (t < 0) {
            tmp.push(o);
          } else {
            state.selectedSection[t] = Object.assign(state.selectedSection[t], o);
          }
        });
        tmp = [...state.selectedSection, ...tmp];
        tmp.sort((a: any, b: any) => {
          if (a.sort > b.sort) {
            return 1;
          } else if (a.sort < b.sort) {
            return -1;
          } else {
            return 0;
          }
        });
        return tmp.filter((o) => o.show);
      }),
      loopSection: computed(() => {
        const tmp = [] as any;
        state.selectedCheckbox.forEach((o) => {
          const t = state.checkboxes.find((i: any) => i.value === o);
          if (t) {
            tmp.push(t);
          }
        });
        return tmp;
      }),
      showQrcode: computed(() => {
        return state.loopSection.some((i) => i.value === "qrcode" && i.show);
      }),
      showAttach: computed(() => {
        return state.loopSection.some((i) => i.value === "attach" && i.show);
      }),
      printConfig: {
        id: "#flow-print-table",
        popTitle: ".",
      },
      isIframe:window.self !== window.top,
    });
    state.selectedCheckbox = state.checkboxes.map((o) => o.value);
    watch(
      () => state.selectedCheckbox,
      (n) => {
        if (n) {
          // console.log(n);
        }
      },
      { immediate: true, deep: true }
    );

    const useDetailApi = () => {
      const api = (url) =>
        HttpService.axios({
          method: "GET",
          url,
        });
      return HttpService.useRequest<any>(api);
    };
    const useAttachListApi = () => {
      const api = (params) =>
        HttpService.axios({
          method: "GET",
          url: "/biz_file/page",
          params,
        });
      return HttpService.usePagination<any>(api);
    };

    const { run, data: basicInfo } = useDetailApi();
    const { run: runBatch, data: attachList } = useAttachListApi();
    watch(
      () => props.url,
      async (n) => {
        if (n) {
          await run(n);
          if (state.showAttach) {
            await runBatch({
              current: 1,
              size: 1000,
              bizId: state.id,
              bizType: props.attachBizType,
            });
            emit("update:attachList", attachList.value);
          }
          emit("update:basicInfo", basicInfo.value);
        }
      },
      {
        immediate: true,
      }
    );
    const cancel = async () => {
      TabService.closeCurrentTab();
      router.back();
      if (state.isIframe) {//收起数据概览
        window.parent.postMessage({ type: 'setShowCard', data: true }, '*');
       }
    };
    watch(
      () => state.printTitle,
      (n, o) => {
        document.title = n;
      },
      { immediate: true }
    );
    watch(
      () => state.selectedCheckbox,
      (n, o) => {
        setDesLabelWidth("ant-descriptions-item-label", props.labelWidth);
      }
    );
    onMounted(() => {
      nextTick(() => {
        setDesLabelWidth("ant-descriptions-item-label", props.labelWidth);
      });
    });
    return {
      ...toRefs(state),
      basicInfo,
      attachList,
      cancel,
    };
  },
});
